var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53 53",
    style: {
      enableBackground: "new 0 0 53 53"
    },
    xmlSpace: "preserve",
    fill: "#FF6B38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,13.5h49c1.1,0,2-0.9,2-2s-0.9-2-2-2H2c-1.1,0-2,0.9-2,2S0.9,13.5,2,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,28.5h49c1.1,0,2-0.9,2-2s-0.9-2-2-2H2c-1.1,0-2,0.9-2,2S0.9,28.5,2,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,43.5h49c1.1,0,2-0.9,2-2s-0.9-2-2-2H2c-1.1,0-2,0.9-2,2S0.9,43.5,2,43.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMenu);
export default __webpack_public_path__ + "static/media/icn-menu.b516d1075a1d3769396b74bed219baaf.svg";
export { ForwardRef as ReactComponent };